import axios from 'axios'

const API_URL = `${process.env.REACT_APP_API_URL}`

const Setups = {
  getUserSetups() {
    return axios({
      method: 'get',
      url: `${API_URL}/setups_per_client`,
    })
  },

  getAllSetups() {
    return axios({
      method: 'get',
      url: `${API_URL}/all_setups`,
    })
  },

  getSetup(name) {
    return axios({
      method: 'get',
      url: `${API_URL}/setup`,
      params: {
        setup_name: name,
      },
    })
  },

  createSetup(setup) {
    return axios({
      method: 'post',
      url: `${API_URL}/add_setup`,
      data: setup,
    })
  },

  deleteSetup(id, name) {
    return axios({
      method: 'delete',
      url: `${API_URL}/setup/${id}`,
      params: {
        setup_name: name,
      },
    })
  },

  updateSetup(updatedSetup) {
    const { id, ...data } = updatedSetup
    return axios({
      method: 'put',
      url: `${API_URL}/edit_setup/${id}`,
      data,
    })
  },

  toggleSetupStatus(setupId) {
    return axios({
      method: 'put',
      url: `${API_URL}/setup_enabled/${setupId}`,
    })
  },
}

export default Setups
